import React from 'react';

interface Lounge3DIconProps {
  size?: number;
  color?: string;
}

export const Lounge3DIcon = ({ size = 48, color = '#2478C8' }: Lounge3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 40);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="16" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Sofa base */}
      <path d="M8 40 L8 52 L56 52 L56 40 C56 36 48 34 32 34 C16 34 8 36 8 40 Z" fill={color} />
      {/* Sofa right side */}
      <path d="M52 34 L56 40 L56 52 L52 52 Z" fill={darkerColor} />
      {/* Sofa back */}
      <path d="M10 24 L10 40 C10 36 18 34 32 34 C46 34 54 36 54 40 L54 24 C54 18 44 16 32 16 C20 16 10 18 10 24 Z" fill={color} />
      {/* Sofa back right */}
      <path d="M50 16 L54 18 L54 40 L50 38 Z" fill={darkerColor} />
      {/* Sofa back top */}
      <path d="M10 24 C10 18 20 16 32 16 C44 16 54 18 54 24" fill={lighterColor} opacity="0.3" />
      {/* Cushion */}
      <ellipse cx="24" cy="38" rx="8" ry="3" fill={lighterColor} opacity="0.2" />
      <ellipse cx="40" cy="38" rx="8" ry="3" fill={lighterColor} opacity="0.2" />
      {/* Arm rests */}
      <rect x="6" y="28" width="6" height="20" rx="3" fill={darkerColor} />
      <rect x="52" y="28" width="6" height="20" rx="3" fill={darkerColor} />
      {/* Legs */}
      <rect x="12" y="52" width="3" height="5" rx="1" fill={darkerColor} />
      <rect x="49" y="52" width="3" height="5" rx="1" fill={darkerColor} />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
